import { render } from "./IqraStudentWeeklySchedule.vue?vue&type=template&id=bd098110&scoped=true"
import script from "./IqraStudentWeeklySchedule.vue?vue&type=script&lang=js"
export * from "./IqraStudentWeeklySchedule.vue?vue&type=script&lang=js"

import "./IqraStudentWeeklySchedule.vue?vue&type=style&index=0&id=bd098110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd098110"]])

export default __exports__